
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {
  IFactoryLoadingPlan,
} from "@/api/types";
import { Message } from "element-ui";
import {
  defaultFactoryLoadingPlanData,
  getFactoryLoadingPlans,
  releaseContainerType,
  removeConfiguredContainer,
  searchFactoryLoadingPlanContainerTypes,
  searchHqPackingList,
  removeFactoryLoadingPlan,
  updateFactoryLoadingPlanStateToShipment,
} from "@/api/factory-loading-plans";
import { cloneDeep, groupBy, uniq } from "lodash";
import {
  ContainerTypeInfo,
  FactoryLoadingPlan,
} from "@/model/FactoryLoadingPlan";
import { HqPackingListType } from "@/commons/HqPackingListType";
import { uploadPackingList } from "@/api/hq-packing-list";
import ContainerTypeReleasedInfo, {
  ContainerTypeReleasedInfoModel,
} from "@/views/components/ContainerTypeReleasedInfo.vue";
import { getShippingOrderContainerTypeReleasedInfo } from "@/api/shipping-order";
import {
  deleteContainerTypeRelations,
  updateContainerTypeLoadingType,
} from "@/api/container-type";
import FactoryLoadingPlanHqPackingListInfoTable, {
  CustomsPackingItem,
  HqPackingListItem,
} from "@/views/components/FactoryLoadingPlanHqPackingListInfoTable.vue";
import ConfigContainerTypeDialog from "@/views/sales-management/components/ConfigContainerTypeDialog.vue";
import AddShippingOrderDialog from "@/views/sales-management/components/AddShippingOrderDialog.vue";
import CreateFactoryLoadingPlanDialog from "@/views/sales-management/components/CreateFactoryLoadingPlanDialog.vue";
import EditFactoryLoadingPlanDialog from "@/views/sales-management/components/EditFactoryLoadingPlanDialog.vue";
import {ElUploadInternalFileDetail} from "element-ui/types/upload";

@Component({
  name: "FactoryLoadingPlan",
  components: {
    FactoryLoadingPlanHqPackingListInfoTable,
    ConfigContainerTypeDialog,
    AddShippingOrderDialog,
    CreateFactoryLoadingPlanDialog,
    EditFactoryLoadingPlanDialog,
    ContainerTypeReleasedInfo,
    Pagination,
  },
})
export default class extends Vue {
  private tableKey = 0;
  private total = 0;
  private listLoading = false;
  private uploadLoading = false;
  private dialogLoading = false;
  private showFileList = false;
  private autoUpload = false;
  private files: any[] = [];
  private IsIndeterminate = false;
  private payload = new FactoryLoadingPlan();
  private factoryLoadingPlanList:any = [];
  private factoryLoadingPlanContainerTypes: ContainerTypeInfo[] = [];
  private releasedMorePlacesFactoryLoadingPlanContainerTypes: ContainerTypeInfo[] =
    [];
  private releasedOnePlaceFactoryLoadingPlanContainerTypes: ContainerTypeInfo[] =
    [];
  private containerTypeReleasedInfo: ContainerTypeReleasedInfoModel =
    new ContainerTypeReleasedInfoModel();
  private currentRow: IFactoryLoadingPlan = defaultFactoryLoadingPlanData;
  private dialogStatus = "";
  private releasedContainerTypeFromVisible = false;
  private batchUploadVisible = false;
  private addShippingOrderDialogVisible = false;
  private addShippingOrderPlan: IFactoryLoadingPlan = null;
  private createDialogVisible = false;
  private editDialogVisible = false;
  private editPlanId: string | null = null;
  private currentRowState = "";
  private listQuery = {
    pageNumber: 1,
    pageSize: 20,
    customerAbbreviationOrCode: null,
    code: null,
    bookingOrderCode: null,
  };

  private showStockUp = false;
  private stockUpTime = null;

  created() {
    this.getList();
  }

  private handleFilter() {
    this.listQuery.pageNumber = 1;
    this.getList();
  }

  private showCreateDialog() {
    this.createDialogVisible = true;
  }

  private showEditDialog(row: IFactoryLoadingPlan) {
    this.editPlanId = row.id;
    this.editDialogVisible = true;
  }

  private showAddShippingOrderDialog(row: IFactoryLoadingPlan) {
    this.addShippingOrderPlan = row;
    this.addShippingOrderDialogVisible = true;
  }

  private closeDialog() {
    this.dialogStatus = "";
    this.releasedContainerTypeFromVisible = false;
    this.releasedMorePlacesFactoryLoadingPlanContainerTypes = [];
    this.releasedOnePlaceFactoryLoadingPlanContainerTypes = [];
    this.factoryLoadingPlanContainerTypes = [];
  }

  private uploadRouter(row) {
    if(row) {
      this.$router.push({
        name: "UploadFactoryPackingList",
        query: {parentCode: row.code}
      });
    } else {
      this.$router.push({
        name: "UploadFactoryPackingList"
      });
    }
  }

  private async getList() {
    this.listLoading = true;
    const params = Object.assign({}, this.listQuery);
    const { content, total }: any = await getFactoryLoadingPlans(params);
    this.factoryLoadingPlanList = content;
    this.factoryLoadingPlanList.map((item,index) => {item.sn = index + 1})
    this.total = total;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private async getFactoryLoadingPlanContainerTypes(id: string) {
    this.listLoading = true;
    await searchFactoryLoadingPlanContainerTypes(id).then((result: any) => {
      this.payload = result;
      this.factoryLoadingPlanContainerTypes = result.unreleasedContainTypes;
      this.releasedMorePlacesFactoryLoadingPlanContainerTypes =
        result.releasedMorePlacesFactoryLoadingPlanContainerTypes.slice();
      this.releasedOnePlaceFactoryLoadingPlanContainerTypes =
        result.releasedOnePlaceFactoryLoadingPlanContainerTypes.slice();
    });
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private async handleUpload(row: any) {
    if (this.files.length == 0) {
      return;
    }
    let formData = new window.FormData();
    formData.append("files", this.files.pop());
    formData.append(
      "type",
      HqPackingListType.FACTORY_LOADING_PLAN.toUpperCase()
    );
    if (row.data) {
      formData.append("code", row.data.code || "");
    }
    await uploadPackingList(formData);
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.files = [];
    await this.getList();
  }
  private async handleBatchUpload() {
    this.uploadLoading = true;
    let formData = new window.FormData();
    this.files.forEach((file) => formData.append("files", file.raw));
    formData.append(
      "type",
      HqPackingListType.FACTORY_LOADING_PLAN.toUpperCase()
    );
    await uploadPackingList(formData)
      .then(() => {
        this.uploadLoading = false;
      })
      .catch(() => {
        this.uploadLoading = false;
      });

    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.clearFiles();
    await this.getList();
  }
  private handleRemove(
    file: ElUploadInternalFileDetail,
    files: ElUploadInternalFileDetail[]
  ) {
    this.files = files.filter((value) => value.name !== file.name);
  }
  private addFile(file: any) {
    if (file.size / 1024 / 1024 >= 100) {
      Message({
        message: "上传的文件大小不能超过100M!",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }

    this.files.push(file);
  }

  private showPackingList(row: FactoryLoadingPlan) {
    if (row) {
      this.$router.push({
        name: "PackingList",
        params: { type: "factory-loading-plan", parentId: row.id },
      });
    }
  }

  private showReleaseContainerTypeLoading = false;
  private async handleReleaseContainerType(row: IFactoryLoadingPlan) {
    this.showReleaseContainerTypeLoading = true;
    this.currentRow = row;
    try {
      await this.getContainerTypeReleasedInfo(row.shippingOrderId);
      this.releasedContainerTypeFromVisible = true;
    }
    catch (error) {
      this.$message.error(error.message);
    }
    finally {
      this.showReleaseContainerTypeLoading = false;
    }
  }

  private async getContainerTypeReleasedInfo(shippingOrderId) {
    try {
      const res:any = await  getShippingOrderContainerTypeReleasedInfo(shippingOrderId, {
        loadingPlanId: this.currentRow.id,
        type: "FACTORY_LOADING_PLAN",
      });
      this.containerTypeReleasedInfo = res;
    }catch (error) {
      this.$message.error(error.message);
    }
  }

  private gotoDocumentFlow(data) {
    this.$router.push({
      name: "DocumentFlow",
      params: { type: "FACTORY_LOADING_PLAN", documentId: data.id },
    });
  }

  private async doReleaseContainerType(
    data: [{ id: string; loadingInOneOrMorePlaces: string }]
  ) {
    await releaseContainerType(this.currentRow.id, { containerTypes: data });
    await this.getContainerTypeReleasedInfo(this.currentRow.shippingOrderId);
  }

  private async doRemoveContainerType(containerTypeId: string) {
    let data = {
      loadingPlanId: this.currentRow.id,
      loadingPlanType: "FACTORY_LOADING_PLAN",
    };
    await deleteContainerTypeRelations(containerTypeId, data);
    await this.getContainerTypeReleasedInfo(this.currentRow.shippingOrderId);
  }

  private async doChangeLoadingType(
    containerTypeId: string,
    loadingInOneOrMorePlaces: boolean
  ) {
    await updateContainerTypeLoadingType(containerTypeId, {
      loadingInOneOrMorePlaces,
    });
    await this.getContainerTypeReleasedInfo(this.currentRow.shippingOrderId);
  }

  private configContainerTypeDialogVisible = false;
  private checkContainerConfigurationDialogVisible = false;

  private showConfigContainerTypeDialog(row: IFactoryLoadingPlan) {
    this.currentRow = row;
    this.configContainerTypeDialogVisible = true;
  }

  private groupByCustomsPackingItems(hqPackingListItems: HqPackingListItem[]) {
    hqPackingListItems.forEach((hqPackingLsit) => {
      const customsPackingItem: CustomsPackingItem[] = [];
      const customsPackingMap = {};
      for (let i = 0; i < hqPackingLsit.customsPackingItems.length; i++) {
        const customsPacking = hqPackingLsit.customsPackingItems[i];
        if (!customsPackingMap[customsPacking.groupId]) {
          customsPackingMap[customsPacking.groupId] = [customsPacking];
        } else {
          customsPackingMap[customsPacking.groupId].push(customsPacking);
        }
      }
      Object.keys(customsPackingMap).forEach((key) => {
        let customsPacking = new CustomsPackingItem();
        if (key == "null") {
          customsPackingMap[key].forEach((c) => {
            customsPackingItem.push(c);
          });
        } else {
          let customsPackingMapElement = customsPackingMap[key];
          customsPacking = customsPackingMapElement[0];
          if (customsPackingMapElement.length - 1 > 0) {
            const unit = customsPacking.code.includes("PLT") ? "托" : "箱";
            customsPacking.code =
              customsPackingMapElement[0].code +
              " \n " +
              "+" +
              (customsPackingMapElement.length - 1 + unit);
          } else {
            customsPacking.code = customsPackingMapElement[0].code;
          }
          customsPackingMapElement.splice(0, 1);
          customsPacking.customsPackingChildernItems = customsPackingMapElement;
          customsPackingItem.push(customsPacking);
        }
      });
      hqPackingLsit.customsPackingItems = customsPackingItem;
    });
  }

  private async getFactoryLoadingPlanPackingInfo() {
    const { hqPackingListItems, containerTypeList, configuredContainers }: any =
      await searchHqPackingList(this.currentRow.id, {
        hqPackingListCode: null,
        factoryName: null,
        containerNumberKeyword: null,
      });
    const hqPackingLists: HqPackingListItem[] = hqPackingListItems.map(
      (value: HqPackingListItem) => {
        const item = new HqPackingListItem();
        Object.assign(item, value);
        item.customsPackingItems = value.customsPackingItems.map((c) => {
          return { select: false, ...c };
        });
        item.toggleSelection = (checked) => {
          for (let customsPackingItem of item.customsPackingItems) {
            customsPackingItem.select = checked;
            if (customsPackingItem.customsPackingChildernItems) {
              customsPackingItem.customsPackingChildernItems.forEach(
                (c) => (c.select = checked)
              );
            }
          }
        };
        return item;
      }
    );
    this.dialogLoading = false;
    return new FactoryLoadingPlanPackingInfoModel(
      containerTypeList,
      configuredContainers,
      hqPackingLists
    );
  }

  // 查看柜型配置
  private checkContainerConfigurationInfos: CheckContainerConfigurationInfoModel[] =
    [];

  private showCheckContainerConfigurationDialog(row: IFactoryLoadingPlan) {
    this.currentRow = row;
    this.checkContainerConfigurationDialogVisible = true;
    this.checkContainerConfigurationInfos = [];
    this.currentRowState = this.currentRow.state.name;
    this.getCheckContainerConfigurationInfos();
  }

  private async getCheckContainerConfigurationInfos() {
    this.dialogLoading = true;
    const factoryLoadingPlanPackingInfoModel: FactoryLoadingPlanPackingInfoModel =
      await this.getFactoryLoadingPlanPackingInfo();
    this.checkContainerConfigurationInfos = this.groupCustomsPackingByContainer(
      factoryLoadingPlanPackingInfoModel
    );
  }

  private groupCustomsPackingByContainer(
    packingInfo: FactoryLoadingPlanPackingInfoModel
  ): CheckContainerConfigurationInfoModel[] {
    const allCustomsPacking: CustomsPackingItem[] =
      packingInfo.hqPackingListItems
        .map((value) => value.customsPackingItems)
        .reduce((pre, cur) => pre.concat(cur), []);
    // 按照柜型分组
    const customsPackingGroupByContainer: {
      [key: string]: CustomsPackingItem[];
    } = groupBy(
      allCustomsPacking,
      (item: CustomsPackingItem) => item.configuredContainerId
    );
    return Object.keys(customsPackingGroupByContainer)
      .map((containerId) => {
        const customsPackingInOneContainer: CustomsPackingItem[] =
          customsPackingGroupByContainer[containerId];
        const customsPackingGroupByHqPackingListId: {
          [key: string]: CustomsPackingItem[];
        } = groupBy(customsPackingInOneContainer, (c) => c.hqPackingListId);
        const hqPackingListItems: HqPackingListItem[] = Object.keys(
          customsPackingGroupByHqPackingListId
        ).map((hqPackingListId) => {
          const hqPackingListItem: HqPackingListItem = cloneDeep(
            packingInfo.hqPackingListItems.filter(
              (h) => h.id === hqPackingListId
            )[0]
          );
          hqPackingListItem.customsPackingItems =
            customsPackingGroupByHqPackingListId[hqPackingListId];
          return hqPackingListItem;
        });
        this.groupByCustomsPackingItems(hqPackingListItems);
        return new CheckContainerConfigurationInfoModel(
          packingInfo.containerTypeList.filter((c) => c.id === containerId)[0],
          hqPackingListItems
        );
      })
      .sort((a, b) => a.container?.name.localeCompare(b.container?.name));
  }

  private async removeConfiguredContainer(customsPackingIds: string[]) {
    await removeConfiguredContainer(this.currentRow.id, customsPackingIds);
    this.checkContainerConfigurationInfos = [];
    await this.getCheckContainerConfigurationInfos();
  }

  private removeConfiguredContainerGroup(row) {
    let customsPackingChildernIds = row.customsPackingChildernItems
      .map((r) => r.id)
      .reduce((pre, cur) => pre.concat(cur), []);
    customsPackingChildernIds.push(row.id);
    this.removeConfiguredContainer(customsPackingChildernIds);
  }

  private batchRemoveConfiguredContainer() {
    let selectedCustomsPackingItems = this.checkContainerConfigurationInfos
      .map((value) => value.hqPackingListItems)
      .reduce((pre, cur) => pre.concat(cur), [])
      .map((h) => h.customsPackingItems)
      .reduce((pre, cur) => pre.concat(cur), []);
    let customsPackingChildrenItems = selectedCustomsPackingItems
      .map((c) => c.customsPackingChildernItems)
      .reduce((pre, cur) => pre.concat(cur), []);
    selectedCustomsPackingItems.push.apply(
      selectedCustomsPackingItems,
      customsPackingChildrenItems
    );
    const selectedCustomsPackingIds = selectedCustomsPackingItems
      .filter((c) => c)
      .filter((c) => c.select)
      .map((c) => c.id);
    if (selectedCustomsPackingIds.length < 1) {
      Message.error({
        message: "请选择主包装",
        duration: 2000,
      });
      return;
    }
    this.removeConfiguredContainer(selectedCustomsPackingIds);
  }
  private async closeCatContainerTypeReleasedInfo() {
    this.checkContainerConfigurationDialogVisible = false;
    await this.getList();
  }

  private async deleteFactoryLoadingPlan(id: string) {
    await removeFactoryLoadingPlan(id);
    this.$notify({
      title: "Success",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }
  private stockUpId = null;

  private async updateFactoryLoadingPlanStateToShipment(id: string) {
    this.stockUpId = id;
    this.showStockUp = true;
  }
  private async confirmStockUp() {
    if(!this.stockUpTime) {
      this.$notify({
        title: "提示",
        message: "请选择日期！",
        type: "warning",
        duration: 2000,
      });
      return
    }
    let params = {
      startDate: this.stockUpTime
    }
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    await updateFactoryLoadingPlanStateToShipment(this.stockUpId,params).then(res => {
      this.showStockUp = false;
      this.stockUpId = null;
      this.stockUpTime = null;
      loading.close();
      this.getList();
    }).catch(err => {
      console.log(err);
      loading.close();
    });
  }
  private clearFiles() {
    this.files = [];
    this.batchUploadVisible = false;
  }

  private renderCusAbbr(prop, row) {
    if (row.pcNames && row.pcNames.length > 0){
      return `[${row.pcNames}]${prop}`
    }
    return prop
  }
}

class CheckContainerConfigurationInfoModel {
  container?: ContainerInfoModel = new ContainerInfoModel();
  hqPackingListItems: HqPackingListItem[];

  constructor(
    container: ContainerInfoModel,
    hqPackingListItems: HqPackingListItem[]
  ) {
    this.container = container;
    this.hqPackingListItems = hqPackingListItems;
  }
}

/**
 * 柜型配置 model
 */
class FactoryLoadingPlanPackingInfoModel {
  containerTypeList: ContainerInfoModel[] = [];
  configuredContainers: ContainerInfoModel[] = [];
  hqPackingListItems: HqPackingListItem[] = [];
  totalWeight: string = null;
  totalVolume: string = null;

  constructor(
    containerTypeList: ContainerInfoModel[],
    configuredContainers: ContainerInfoModel[],
    hqPackingListItems: HqPackingListItem[]
  ) {
    this.containerTypeList = containerTypeList;
    this.configuredContainers = configuredContainers;
    this.hqPackingListItems = hqPackingListItems;
  }
}

class ContainerInfoModel {
  id: string;
  containerNumber: string;
  containerTypeCode: string;
  loadingInOneOrMorePlaces: true;
  name: string;
  sealNumber: string;
  value: string;
  volume: string;
  remark: string;
}
